export const SICK_BASIC_REGIONS: Array<{ name: string; value: string }> = [{ name: 'Europe', value: 'europe' }];
